import * as React from "react";
import ToggleButton from "../../ToggleButton";
import "./pillListItem.style.css";

interface IProps {
  className?: string;
  onClick?: (id: string) => void;
  text: string;
  id: string;
  ticked?: boolean;
}

{
  /* <ToggleButton
className="pillListItem__toggle"
on={ticked}
onClick={(isOn: boolean) => {
  if (onClick) {
    onClick(id, isOn);
  }
}}
/> */
}
const PillListItem = ({
  className = "",
  onClick,
  text,
  ticked = false,
  id,
}: IProps) => (
  <li
    className={`pillListItem
        ${className}
        ${ticked ? "-checked" : ""}
    `}
  >
    <span
      className={`pillListItem__label `}
      onClick={() => {
        if (onClick) {
          onClick(id);
        }
      }}
    >
      <span className="pillListItem__text">{text}</span>
    </span>
  </li>
);

export default PillListItem;
